import React from 'react'
import { useTranslation } from 'react-i18next';
import NpsQuestion from './NpsQuestion';
import { useSelectLanguage } from '../../hooks/global/Languages';

export default function Nps({ value,  question , onChange, sourceId}) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.toUpperCase();
  const id = question.id + "" + sourceId;

  
  const { selectTextByLanguage } = useSelectLanguage();

  const handleChange = (questionId, value) => {
    onChange?.(question, value);
  }

  return (
    <div className="margin-bottom-40" >
    <div className="reviewInvite-question nps">
        <h3 className="text-left">{selectTextByLanguage(question.text,lng)}</h3>
        <NpsQuestion sourceId={sourceId} questionId={question.id} onChange={handleChange} value={value} />
        <p className="textareaRequired">{/*"this.props.validationErrors[this.props.sourceId][question.id]"*/}</p> 
    </div>
</div>
  )
}
